import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import { CampaignRecord, getCampaigns } from '@/apis/campaigns';
import { labelSorting } from '@/util/labelSorting';

export const useLookupCampaigns = () => {
  const { getAccessTokenSilently } = useAuth0();

  return useCallback(
    async (lookupValue: string) => {
      const token = await getAccessTokenSilently();

      return (await getCampaigns(token, lookupValue))
        .map((x: CampaignRecord) => {
          return { id: x.id, label: x.title };
        })
        .sort(labelSorting);
    },
    [getAccessTokenSilently]
  );
};
